// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

.responsePageNotFound {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;
  gap: 14px;
  height: 100vh;
  justify-content: space-between;
}
.footerImage {
  width: 100%;
}

.divErrorDescription {
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  font-size: var(--label-FontSize);
  line-height: 21.28px;
  color: var(--default-FontColour);
  padding-top: 0px;
  position: relative;
  z-index: 1;
}
.divErrorCodeDescription {
  font-family: var(--default-FontName);
  font-weight: var(--sub-header-FontWeight);
  font-size: var(--mainheading-FontSize);
  line-height: 31.92px;
  color: var(--button-color);
}
.responsePageNotFound__footerImage {
  bottom: -3px;
  position: fixed;
  width: 100%;
}
.responsePageNotFound__pageImageGroup {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f9f9f9;
  gap: 14px;
  justify-content: space-between;
  padding-top: 10vh;
}

.divErrorImage {
  padding-top: 41px;
  position: relative;
  z-index: 1;
}
.divBackButton {
  padding-top: 25px;
}
.responsePageNotFound .button.MuiButton-root,
.responsePageNotFound .button.MuiButton-root {
  border-radius: 4px;
  z-index: 3;
}

img.marstonGroupImage {
  width: 18.229vw;
}

img.Image404 {
  width: 30.885vw;
}
@media screen and (min-width: 400px) and (max-width: 1100px) {
  .responsePageNotFound__pageImageGroup {
    padding-top: 60px;
  }
}
@media screen and (min-width: 1300px) and (max-width: 1380px) {
  .responsePageNotFound__pageImageGroup {
    padding-top: 30px;
  }
  .divErrorImage {
    padding-top: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/responseErrorCode/ResponseErrorCode.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,sCAAsC;EACtC,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n.responsePageNotFound {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #f9f9f9;\n  gap: 14px;\n  height: 100vh;\n  justify-content: space-between;\n}\n.footerImage {\n  width: 100%;\n}\n\n.divErrorDescription {\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  font-size: var(--label-FontSize);\n  line-height: 21.28px;\n  color: var(--default-FontColour);\n  padding-top: 0px;\n  position: relative;\n  z-index: 1;\n}\n.divErrorCodeDescription {\n  font-family: var(--default-FontName);\n  font-weight: var(--sub-header-FontWeight);\n  font-size: var(--mainheading-FontSize);\n  line-height: 31.92px;\n  color: var(--button-color);\n}\n.responsePageNotFound__footerImage {\n  bottom: -3px;\n  position: fixed;\n  width: 100%;\n}\n.responsePageNotFound__pageImageGroup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #f9f9f9;\n  gap: 14px;\n  justify-content: space-between;\n  padding-top: 10vh;\n}\n\n.divErrorImage {\n  padding-top: 41px;\n  position: relative;\n  z-index: 1;\n}\n.divBackButton {\n  padding-top: 25px;\n}\n.responsePageNotFound .button.MuiButton-root,\n.responsePageNotFound .button.MuiButton-root {\n  border-radius: 4px;\n  z-index: 3;\n}\n\nimg.marstonGroupImage {\n  width: 18.229vw;\n}\n\nimg.Image404 {\n  width: 30.885vw;\n}\n@media screen and (min-width: 400px) and (max-width: 1100px) {\n  .responsePageNotFound__pageImageGroup {\n    padding-top: 60px;\n  }\n}\n@media screen and (min-width: 1300px) and (max-width: 1380px) {\n  .responsePageNotFound__pageImageGroup {\n    padding-top: 30px;\n  }\n  .divErrorImage {\n    padding-top: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
